import { useState } from 'react';
import Button from 'components/Button';
import pluralize from 'utils/pluralize';
import {
    formatDateTime,
    fromLocalInput,
    isReleasedRaw,
    isThin,
    rerawMarker,
    toLocalInput,
} from 'utils/newsroom';
import styles from 'styles/modules/newsAlert/Newsroom.module.scss';

const rawStatus = (alert) => {
    if (alert.rawAt && !isReleasedRaw(alert)) {
        return `A Raw, held out of the archive until ${formatDateTime(
            alert.rawExclusiveUntil
        )}.`;
    }
    if (alert.rawAt) {
        const reraw = rerawMarker(alert);
        return `In the Raws archive since ${formatDateTime(alert.rawAt)}.${
            reraw ? ` ${reraw}.` : ''
        }`;
    }
    if (alert.rawReviewedAt) {
        return `Marked Not a Raw on ${formatDateTime(alert.rawReviewedAt)}.`;
    }
    return 'Not reviewed yet.';
};

// Raw: brands the alert as a Newspage Raw and adds it to the archive that
// journalists search. A person decides: thin alerts get a second look.
const RawPanel = ({
    alert,
    responsesCount,
    busy,
    onRaw,
    onReraw,
    onNotRaw,
    onClose,
}) => {
    const [exclusive, setExclusive] = useState(
        toLocalInput(alert.rawExclusiveUntil)
    );
    const thin = isThin(responsesCount);

    return (
        <section className={styles.rawPanel} aria-label="Raw">
            <p className={styles.rawStatus}>{rawStatus(alert)}</p>

            <p>
                {`${responsesCount} ${pluralize(responsesCount, 'response')}.`}{' '}
                A Raw should be something you could see a journalist running.
            </p>

            {thin && (
                <p className={styles.thinWarning}>
                    {responsesCount === 0
                        ? 'No responses yet.'
                        : 'Only one response.'}{' '}
                    Thin Raws weaken the archive journalists search. Would a
                    journalist run this?
                </p>
            )}

            <label className={styles.label} htmlFor="raw-exclusive">
                Keep out of the archive until (optional, for an exclusive)
            </label>
            <input
                id="raw-exclusive"
                type="datetime-local"
                className={styles.input}
                value={exclusive}
                onChange={(e) => setExclusive(e.target.value)}
            />

            <div className={styles.rawActions}>
                <Button
                    title={
                        alert.rawAt
                            ? 'Update Raw'
                            : thin
                            ? 'Raw it anyway'
                            : 'Make it a Raw'
                    }
                    loading={busy === 'raw'}
                    onClick={() => onRaw(fromLocalInput(exclusive))}
                />
                {isReleasedRaw(alert) && (
                    <Button
                        theme={'secondary'}
                        title={'ReRaw'}
                        loading={busy === 'reraw'}
                        onClick={onReraw}
                    />
                )}
                <Button
                    theme={'secondary'}
                    title={alert.rawAt ? 'Remove from Raws' : 'Not a Raw'}
                    loading={busy === 'notRaw'}
                    onClick={onNotRaw}
                />
                <Button
                    theme={'secondary'}
                    title={'Cancel'}
                    onClick={onClose}
                />
            </div>
        </section>
    );
};

export default RawPanel;
